import React from "react";
import Image from "components/image";
import Link from "helpers/link";
import { PortableText } from "@portabletext/react";
import getButtonStyle from "helpers/get-button-style";

const Video = ({ value }) => {
    const { controls, autoplay, muted, loop, video } = value;
    return (
        <video className="w-full py-4" controls={controls} autoPlay={autoplay} muted={muted} loop={loop}>
            <track kind="captions" />
            <source src={video} type="video/mp4" />
            Your browser does not support HTML5 video.
        </video>
    );
};

const VideoEmbed = ({ value: node }) => {

    let alignMapping = {
        left: 'justify-start',
        center: 'justify-center',
        right: 'justify-end',
    }

    let ratioMapping = {
        default: 'pt-[56%]',
        wide: 'pt-[42%]',
        square: 'pt-[75%]',
    }    

    return (
        <div class={`flex ${alignMapping[node.videoAlign]}`}>
            <div className="!w-full" style={{ maxWidth: node.maxWidth }}>
                <div className={`relative ${ratioMapping[node.ratio]}`} >
                    <iframe className="absolute top-0 bottom-0 left-0 right-0 !h-full !w-full" src={node.url} title={node.title}></iframe>
                </div>
            </div>
        </div>
    )
}

// Types
const ImageRenderer = ({ value: node }) => <Image image={node} alt={node.alt} to={node.url} />;

const ImageWithWidthRenderer = ({ value: node }) => <Image image={node} alt={node.alt} to={node.url} width={node.width} />;

const ButtonRenderer = ({ value: node }) => (
    <Link className={getButtonStyle(node?.style)} to={node?.url}>
        {node?.text}
    </Link>
);

// Marks
const Links = ({ children, value }) => <Link className="pb-[0.063rem] leading-7 border-b border-b-gray-601" to={value.href}>{children}</Link>;

const TextSettings = ({ children, value }) => (
    <span style={{
        display: "block", color: value?.color?.hex, textAlign: value?.alignment, 
    }}
    >
        {children}
    </span>
);

export const richTextComponents = {
    types: {
        // table: TableSerializer,
        Image: ImageRenderer,
        ImageWithWidth: ImageWithWidthRenderer,
        Button: ButtonRenderer,
        Video,
        videoEmbed: VideoEmbed,
    },
    marks: {
        link: Links,
        textSettings: TextSettings,
    },

};

const SmallRichText = ({ value, data, ...other }) => <PortableText value={value ?? data?.data} components={richTextComponents} {...other} />;

export default SmallRichText;
